export const Durations = {
  secondsInMinute: 60,
  secondsInHour: 3600,
  secondsInDay: 86400
};
